<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Groups'"
      [canGoBack]="!windowService.isDesktopRes"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Organize your users and properties into groups to control access, notifications, billing, and reporting.'" />
      </tidy-row>
      <tidy-button
        [action]="boundGoToAddTeamPage"
        [text]="'Add Group'"
        class="primary" />
      @if (teamsList?.length) {
        <tidy-team-tree
          [teamsList]="teamsList" />
      }
      @if (!teamsList?.length) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'No groups added'" />
          </tidy-row>
        </tidy-alert>
      }
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Need help setting up groups?'" /><span>&nbsp;</span>
          <tidy-text
            class="link"
            [body]="'Learn More'"
            (action)="goToTeamsHelpUrl()" />
        </tidy-row>
      }

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

    </tidy-wrapper>
  </ng-template>


  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
